<template lang="pug">
erp-view(id="ControlUsuarios" ref="ControlUsuarios" title="Control de Usuarios" blank=true 
  :hide-header-title="true" )   
  // 🔹 BOTÓN PRINCIPAL DE ACCIÓN
  template(slot="header-action")  
      dx-button(
        @click="agregarUsuario"
        icon="fa fa-user-plus"
        text="Agregar Usuario"
        type="success"
        class="btn-agregar-usuario"
      )

  // 🔹 CONTENIDO PRINCIPAL
  template(slot="content")

    GestionUsuarioPopup(ref="GestionUsuarioPopupCmp")


    // 🔹 GRID DE USUARIOS
    dx-data-grid(
      :data-source="listas.listarUsuarios"
      :allow-column-reordering="true" 
      :row-alternation-enabled="true"
      :show-row-lines="true"
      :show-borders="false"
      :column-auto-width="true"
      height="600" 
      column-resizing-mode="widget"
      :allow-column-resizing="true" 
    )
    
      dx-header-filter(:visible="true" :allow-search="true")
      dx-filter-row(:visible="true")
      dx-column-fixing(:enabled="true")
      dx-scrolling(mode="virtual")
      dx-export(:enabled="true" file-name="LISTA DE USUARIOS")  
      dx-editing(:allow-updating="true" mode="cell") 

      // 🔹 COLUMNAS ORIGINALES
      dx-column(data-field="codEmpleado" caption="Cod. Empleado" alignment="center" :width="130" :allow-editing="false" cell-template="estado")
      dx-column(data-field="documento" caption="Documento" alignment="center" :width="120" :allow-editing="false" cell-template="estado")
      dx-column(data-field="nombresCompletos" caption="Nombre Completo" :width="260" :allow-editing="false" cell-template="estado")
      dx-column(data-field="usuarioRed" caption="Usuario Red" :width="150" :allow-editing="false" cell-template="estado")
      dx-column(data-field="fechaIngreso" caption="Fecha Ingreso" :width="130" :allow-editing="false" cell-template="estado")
      dx-column(data-field="correoElectronico" caption="Correo Electrónico" :width="260" :allow-editing="false" cell-template="estado")
      dx-column(data-field="tipoVinculacion" caption="Tipo Vinculación" alignment="center" :width="150" :allow-editing="false" cell-template="estado")
      dx-column(data-field="nombreCargo" caption="Cargo" :width="220" :allow-editing="false" cell-template="estado")
      dx-column(data-field="nombreCargoKactus" caption="CargoKactus" :width="220" :allow-editing="false" cell-template="estado")
      dx-column(data-field="estado" caption="Estado" alignment="center" :width="110" :allow-editing="false" cell-template="estado")
      dx-column(data-field="estadoKactus" caption="EstadoKactus" alignment="center" :width="110" :allow-editing="false" cell-template="estado")

      dx-column(caption="Configurar" cell-template="tpl-modificar")
      dx-column(caption="Accion" cell-template="tpl-activar-desactivar")
      // 🔹 NUEVA COLUMNA: ESTADO SESIÓN (AGREGADO + FILTRO)
      dx-column(
        caption="Sesión"
        data-field="estadoSesion"
        alignment="center"
        :width="130"
        :calculate-cell-value="calcularSesion"
        cell-template="tpl-sesion"
      )

      // 🔹 NUEVA COLUMNA: CERRAR SESIÓN (AGREGADO + FILTRO)
      dx-column(
        caption="Cerrar Sesión"
        data-field="cerrarSesionEstado"
        alignment="center"
        :width="150"
        :calculate-cell-value="calcularCerrarSesion"
        cell-template="tpl-cerrar-sesion"
  )
      // 🔹 PLANTILLAS PERSONALIZADAS ORIGINALES
      template(#tpl-modificar="{ data }")
        a.link.green(
          v-if="data.data.estado == 'ACTIVO'" 
          @click="configurarUsuario(data.data)") 
          i.fa.fa-cog.me-1
          | Configurar

      // 🔹 ACTIVAR / DESACTIVAR (ORIGINAL)
      template(#tpl-activar-desactivar="{ data }")
        div
          a.link.red.btn-desactivar(
            v-if="data.data.estado == 'ACTIVO'"
            @click="desactivarUsuario(data.data)"
          )
            i.fa.fa-ban.me-1
            | Desactivar

          a.link.green.btn-activar(
            v-else
            @click="activarUsuario(data.data)"
          )
            i.fa.fa-check.me-1
            | Activar

      template(#estado="{ data }")
        span(:class="data.data.estado == 'INACTIVO' ? 'estado-inactivo' : 'estado-activo'") {{ data.text }}

      // 🔹 TEMPLATE NUEVO: ESTADO DE SESIÓN
      template(#tpl-sesion="{ data }")
        span(:class="data.data.conectado ? 'estado-activo' : 'estado-inactivo'")
          i.fa.fa-circle.me-1
          | {{ data.data.conectado ? 'Conectado' : 'Desconectado' }}

      // 🔹 TEMPLATE NUEVO: CERRAR SESIÓN
      template(#tpl-cerrar-sesion="{ data }")
        a.link.red.btn-desactivar(
          v-if="data.data.conectado"
          @click="cerrarSesionUsuario(data.data)"
        )
          i.fa.fa-power-off.me-1
          | Cerrar Sesión
        span(v-else style="color:#9ca3af") No disponible
</template>

<script>
import controlUsuarioResource from "@/api/ControlUsuarioResource.js";
import { confirm } from "devextreme/ui/dialog";

export default {
  data: () => ({
    listaOts: [],
    modelo: { Id: 0 },
    carga: 0,
    listas: { listarUsuarios: [] }
  }),
  mounted() {
    this.inicio();
    this.$refs.GestionUsuarioPopupCmp.$on("popupClosed", this.CerrarPopup);
 
  },
  methods: {
    calcularSesion(row) {
      return row.conectado ? "Conectado" : "Desconectado";
    },
    calcularCerrarSesion(row) {
      return row.conectado ? "Disponible" : "No disponible";
    },
    // 🔹 NUEVO — CERRAR SESIÓN (AGREGADO)
    cerrarSesionUsuario(data) {
      if (!data.id) {
        this.$msg.error("El Usuario no EXISTE");
        return;
      }

      confirm("¿Deseas CERRAR la sesión del usuario?", "Control de Usuarios").then((res) => {
        if (res) {
          this.$refs.ControlUsuarios.wait(true);

          controlUsuarioResource
            .cerrarSesionUsuario(data.id) // tu endpoint
            .then(() => {
              this.$msg.success("Sesión cerrada correctamente");
              this.cargarListaUsuarios();
            })
            .catch((err) => this.$msg.handleError(err, "Cerrar sesión"))
            .finally(() => this.$refs.ControlUsuarios.wait(false));
        }
      });
    },

    // 🔹 DESACTIVAR USUARIO (ORIGINAL)
    desactivarUsuario(data) {

      if (data.id == null) {
        this.$msg.error("El Usuario no EXISTE");
        return;
      }
      confirm("¿Deseas DESACTIVAR al usuario?", "Control de Usuarios").then((res) => {
        if (res) {
          this.$refs.ControlUsuarios.wait(true);
          controlUsuarioResource
            .desactivarUsuario(data.id)
            .then(() => {
              this.$msg.success("Usuario desactivado");
              this.cargarListaUsuarios();
            })
            .catch((err) => this.$msg.handleError(err, "Desactivar usuario"))
            .finally(() => this.$refs.ControlUsuarios.wait(false));
        }
      });
    },

    // 🔹 ACTIVAR USUARIO (ORIGINAL)
    activarUsuario(data) {
      if (data.id == null) {
        this.$msg.error("El Usuario no EXISTE");
        return;
      }
      confirm("¿Deseas ACTIVAR al usuario?", "Control de Usuarios").then((res) => {
        if (res) {
          this.$refs.ControlUsuarios.wait(true);
          controlUsuarioResource
            .activarUsuario(data.id)
            .then(() => {
              this.$msg.success("Usuario activado");
              this.cargarListaUsuarios();
            })
            .catch((err) => this.$msg.handleError(err, "Activar usuario"))
            .finally(() => this.$refs.ControlUsuarios.wait(false));
        }
      });
    },

    agregarUsuario() {
      this.carga = 0;
      this.$refs.GestionUsuarioPopupCmp.show(0);
    },

    configurarUsuario(data) {
      if (data.id == null) {
        this.$msg.error("El Usuario no EXISTE");
        return;
      }
      this.carga = 0;
      this.modelo.id = data.id;
      this.$refs.GestionUsuarioPopupCmp.show(this.modelo.id);
    },

    inicio() {
      this.cargarListaUsuarios();
    },

    cargarListaUsuarios() {
      this.$refs.ControlUsuarios.wait(true);
      controlUsuarioResource
        .obtenerListaUsuarios()
        .then((res) => {
          this.listas.listarUsuarios = res.data.listarUsuarios;
          this.$refs.ControlUsuarios.wait(false);
        })
        .catch((err) => {
          this.$msg.handleError(err, "Obtener lista de usuarios");
          this.$refs.ControlUsuarios.wait(false);
        });
    },

    CerrarPopup() {
      this.carga++;
      if (this.carga === 1) {
        confirm("¿Desea cargar nuevamente la información?", "Registros de Usuarios")
          .then((res) => {
            if (res) this.cargarListaUsuarios();
          });
      }
    },
  },
};
</script>

<style scoped>
/* ===== CONTENEDOR GENERAL ===== */
.usuarios-container {
  background: #f9fafb;
  padding: 20px;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
}

/* ===== BOTONES ===== */
.btn-activar {
  color: #16a34a !important;
  font-weight: 600;
}

.btn-desactivar {
  color: #dc2626 !important;
  font-weight: 600;
}

.btn-desactivar:hover {
  color: #b91c1c !important;
}

/* ===== ESTADOS ===== */
.estado-activo {
  color: #16a34a;
  font-weight: 600;
}

.estado-inactivo {
  color: #dc2626;
  font-weight: 600;
}

/* ===== LINKS ===== */
.link {
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}

</style>
